import React from "react";
import { styled } from '@mui/material/styles';
import { LinearProgress, Grid } from "@mui/material";

const PREFIX = 'Loader';

const classes = {
  loader: `${PREFIX}-loader`
};

const StyledGrid = styled(Grid)((
  {
    theme
  }
) => ({
  [`&.${classes.loader}`]: {
    marginTop: theme.spacing(5)
  }
}));

function Loader({ testid = "loading" }) {

  return (
    <StyledGrid className={classes.loader} data-testid={testid} size={12}>
      <LinearProgress />
    </StyledGrid>
  );
}

export default Loader;
